export const fr = {
  'contact.header': 'Informations de contact',

  'contacts.header': 'Mes contacts',
  'contacts.create': 'Nouveau contact',
  'contacts.edit': 'Modifier le contact',

  'welcome.header': "Page d'accueil",
  'welcome.login-form.email': 'Email',
  'welcome.login-form.password': 'Mot de passe',

  'events.header': 'Mes événements',
  'events.create': 'Nouvel évènement',
  'events.edit': "Modifier l'événement",

  'home.header': 'Maison',
  'profile.header': 'Mon profil',
  'profile.logout': 'Se déconnecter',
  'settings.header': 'Mes paramètres',
  'forgot-login.header': 'Mot de passe oublié',
  'forgot-login.button.reset': 'Instructions de réinitialisation des e-mails',

  'registration.header': 'Inscription gratuite des membres',
  'registration.form.country': 'De campagne',
  'registration.form.language': 'Langue',
  'registration.button.continue': 'Continuez à configurer votre compte',
  'registration.button.sign-in': "S'identifier",
  'registration.text.acknowledge':
    "En créant un compte, vous reconnaissez avoir lu notre politique de confidentialité et accepter nos conditions d'utilisation.",
  'registration.text.registered': 'Vous avez déjà un compte?',

  'validation.messages.required': 'Obligatoire',
  'validation.messages.length': 'La longueur doit être comprise entre {0} et {1} symboles',
  'validation.messages.email': "La valeur saisie n'est pas un e-mail valide",

  'button.submit': 'Nous faire parvenir',
  'button.login': 'Connexion',
  'button.back': 'Retour',
  'button.cancel': 'Annuler',
  'button.settings': 'Réglages',
  'button.forgot-login': 'Mot de passe oublié',
  'button.registration': 'Inscription gratuite des membres',

  'menu.admin': 'Admin',
  'menu.lots-empty': 'Empty Lots',
  'menu.lots': 'Lots',
  'menu.waybills': 'Waybills',
  'menu.waybill-imports': 'Imports PDF',
  'menu.bvs': 'BVs',
  'menu.dashboard-global': 'Tableau de bord global',
  'menu.campaigns': 'Campagnes',
  'menu.counterparties': 'Tierces parties',
  'menu.cvs': 'CVs de déblocage',
  'menu.cv-group': 'CVs',
  'menu.cv-executions': "CVs d'exécution",
  'menu.products': 'Produits',
  'menu.addresses': "Carnet d'adresses",
  'menu.counterparty-contracts': 'Contrats',
  'menu.contract-line-items': 'Fixation',
  'menu.proposal': 'Propositions',
  'menu.boardings': 'Embarquements',
  'menu.boarding-imports': 'Imports SI',
  'menu.transit-orders': 'Ordres de transit',
  'menu.containers': 'Conteneurs',
  'menu.transfers': 'Transferts',
  'menu.formulas': 'Formules',
  'menu.farmers': 'Producteurs',
  'menu.farms': 'Exploitations',
  'menu.attachment-history': 'Historique des fichiers',
  'menu.consortiums': 'Consortiums',
  'menu.cooperatives': 'Coopératives',

  // Admin descriptions
  'menu.campaigns.description': 'Gérer les campagnes',
  'menu.counterparties.description': 'Carnet de sociétés et tierces parties',
  'menu.consortiums.description': 'Gérer les consortiums',
  'menu.cooperatives.description': 'Gérer les coopératives et fournisseurs',
  'menu.farmers.description': 'Gérer les producteurs',
  'menu.farms.description': 'Gérer les exploitations',
  'menu.products.description': 'Catalogue des produits',
  'menu.addresses.description': "Carnet d'adresses",
  'menu.containers.description': 'Gérer les conteneurs',

  // Common pages
  'common.access-denied.title': 'Accès refusé',
  'common.access-denied.p1': 'Vous ne disposez pas des autorisations nécessaires pour accéder à cette page.',
  'common.access-denied.p2': 'Pour plus de détails, veuillez contacter le service client.',
  'common.back-home': 'Retour à la maison',
  'common.warning': 'Attention',
  'common.search': 'Rechercher...',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.unknown': 'Inconnu',
  'common.note': 'Nota',
  'common.month.1': 'Janvier',
  'common.month.2': 'Février',
  'common.month.3': 'Mars',
  'common.month.4': 'Avril',
  'common.month.5': 'Mai',
  'common.month.6': 'Juin',
  'common.month.7': 'Juillet',
  'common.month.8': 'Août',
  'common.month.9': 'Septembre',
  'common.month.10': 'Octobre',
  'common.month.11': 'Novembre',
  'common.month.12': 'Décembre',

  // Table
  'table.actions': 'Comportamiento',
  'table.edit': 'Editar',
  'table.delete': 'Borrar',
  'table.report': 'Informe',
  'table.download': 'Télécharger',
  'table.notes': 'Remarques',

  // Admin
  'admin.title': "Page d'administration",
  'admin.section.partners': 'Partenaires et tierces parties',
  'admin.section.catalog': 'Catalogue',
  'admin.section.logistics': 'Adresses et logistique',
  'admin.section.other': 'Autre',
  'admin.section.audit': 'Audit',
  'menu.attachment-history.description': 'Historique de toutes les pièces jointes',

  // Addresses
  'addresses.add-new': "Ajoutez l'adresse",
  'addresses.create-new': 'Créer une adresse',
  'addresses.address-number': 'Adresse #{0}',
  'addresses.name': 'Nom',
  'addresses.type': 'Taper',
  'addresses.country': 'De campagne',
  'addresses.city': 'Ville',
  'addresses.street': 'Rue',
  'addresses.street2': 'Rue 2',

  // BVs
  'bvs.add-new': 'Ajouter BV',
  'bvs.create-new': 'Créer BV',
  'bvs.bv-number': 'BV #{0}',
  'bvs.number': 'N° de BV',
  'bvs.name': 'Nom',
  'bvs.status': 'Statut',
  'bvs.acceptance-date': "Date D'acceptation",
  'bvs.expiration-date': "Date D'expiration",
  'bvs.lots': 'Lots',
  'bvs.status.BV': 'BV',
  'bvs.status.BA': 'BA',
  'bvs.status.BV request made': 'BV demande faite',
  'bvs.status.BV to ask': 'BV à demander',
  'bvs.status.Request for extension': "Demande d'extension",
  'bvs.status.Rework request made': 'Demande de reprise effectuée',

  // Campaigns
  'campaigns.add-new': 'Ajouter une campagne',
  'campaigns.create-new': 'Créer une campagne',
  'campaigns.campaign-number': 'Campagne #{0}',
  'campaigns.formIntroTitle': 'Fonctionnement des saisons et des imports',
  'campaigns.formIntroDescription':
    "Une ligne de campagne définit à la fois la fenêtre de grande récolte et celle de mi-récolte. Les imports (conos, lots) déterminent la campagne à partir d'une date d'événement (ex. pesée/analyse ou date de production) : elle doit tomber dans l'une ou l'autre fenêtre. Il doit y avoir exactement une campagne correspondante ; aucune correspondance ou plusieurs saisons qui se chevauchent font échouer l'import.\n\nLe nom doit respecter [AAAA] Libellé ou [AAAA - AAAA] Libellé (espace après ]). La première année entre crochets est l'ancre de saison et remplit automatiquement le champ Année ci-dessous — vous ne modifiez que le nom. Avec deux années entre crochets, la deuxième sert, avec l'ancre, à rattacher la mi-récolte à la bonne année civile lorsque la grande récolte chevauche deux ans ; avec [AAAA] seul, la mi-récolte suit uniquement l'année d'ancrage.\n\nL'année d'ancrage n'est pas l'année civile de chaque événement. Lorsque la fenêtre grande récolte chevauche le 1er janvier (mois/jour de début plus tard dans l'année que la fin), le premier segment relève de l'année civile d'ancrage et le segment après le 1er janvier de l'année suivante — ex. ancre 2024 avec grande récolte oct. 2024–mars 2025 : le mars en question est mars 2025. Les valeurs par défaut sont souvent oct.–mars et avr.–sept. ; mois et jour sont ajustables selon le déploiement (dans les limites de la validation).",
  'campaigns.formIntroHelpAriaLabel': 'En savoir plus sur les saisons et les imports',
  'campaigns.sectionIdentity': 'Nom et clé de saison',
  'campaigns.sectionMainCrop': 'Fenêtre grande récolte',
  'campaigns.sectionMidCrop': 'Fenêtre mi-récolte',
  'campaigns.name': 'Nom',
  'campaigns.namePatternError': 'Utilisez [AAAA] Libellé ou [AAAA - AAAA] Libellé (espace après ]).',
  'campaigns.nameExtra':
    "Utilisez [AAAA] Libellé ou [AAAA - AAAA] Libellé (espace après ]). Le libellé après les crochets est libre. La forme à deux années n'est pas qu'un affichage : la deuxième année entre crochets aide à placer la mi-récolte dans la bonne année civile lorsque la grande récolte chevauche deux années. Ex. : [2024 - 2025] Campagne. La première année entre crochets renseigne automatiquement l'année d'ancrage ci-dessous.",
  'campaigns.year': "Année d'ancrage de la saison",
  'campaigns.yearExtra':
    "Renseignée automatiquement à partir de la première année entre crochets du nom. C'est l'année civile du premier segment de la fenêtre grande récolte lorsqu'elle chevauche le Nouvel An (règle pratique : l'année civile du début « côté automne »). Ex. : nom [2024 - 2025] Campagne → 2024.",
  'campaigns.mainStartMonth': 'Grande récolte — mois de début',
  'campaigns.mainStartDay': 'Grande récolte — jour de début',
  'campaigns.mainEndMonth': 'Grande récolte — mois de fin',
  'campaigns.mainEndDay': 'Grande récolte — jour de fin',
  'campaigns.mainWindowExtra':
    "Lorsque le début est plus tard dans l'année que la fin, la fenêtre chevauche l'année civile : la fin tombe dans l'année suivante (ex. oct.→mars). Les défauts sont souvent oct.–mars ; mois et jour modifiables dans les limites de la validation.",
  'campaigns.midStartMonth': 'Mi-récolte — mois de début',
  'campaigns.midStartDay': 'Mi-récolte — jour de début',
  'campaigns.midEndMonth': 'Mi-récolte — mois de fin',
  'campaigns.midEndDay': 'Mi-récolte — jour de fin',
  'campaigns.midWindowExtra':
    "En général sur une seule année civile (ex. avr.–sept.). Même ligne de campagne que la grande récolte ; l'année civile retenue dépend de l'ancre Année et, pour un nom [AAAA - AAAA], de la deuxième année entre crochets.",

  // Cooperatives
  'cooperative.isEudrCompliant': 'Conforme EUDR',
  'cooperatives.add-new': 'Ajouter un coopératif',
  'cooperatives.create-new': 'Créer un coopératif',
  'cooperatives.cooperative-number': 'Coopératif #{0}',

  // Consortiums
  'consortiums.add-new': 'Ajouter un consortium',
  'consortiums.create-new': 'Créer un consortium',
  'consortiums.consortium-number': 'Consortium #{0}',
  'consortiums.cooperatives': 'Coopératifs',

  // Countcerparties
  'counterparties.add-new': 'Ajouter une contrepartie',
  'counterparties.create-new': 'Créer une contrepartie',
  'counterparties.counterparties-number': 'Contrepartie #{0}',
  'counterparties.name': 'Nom',
  'counterparties.code': 'Code',
  'counterparties.type': 'Taper',
  'counterparties.consortium': 'Consortium',
  'cooperatives.isEudrCompliant': 'Conforme EUDR',

  // Countcerparty Contracts
  'counterparty-contracts.add-new': 'Ajouter un contrat',
  'counterparty-contracts.create-new': 'Créer un contrat',
  'counterparty-contracts.contract-number': 'Contracter #{0}',
  'counterparty-contracts.counterparty': 'Contrepartie',
  'counterparty-contracts.client': 'Client',
  'counterparty-contracts.client-contract': 'Contrat client',
  'counterparty-contracts.shipowner-contract': "Contrat d'armateur",
  'counterparty-contracts.shipping-contract': 'Contrat expédition',
  'counterparty-contracts.volume': 'Volume',
  'counterparty-contracts.price': 'Prix',
  'counterparty-contracts.statistics': 'Statistiques',
  'counterparty-contracts.accepted': 'Accepté',
  'counterparty-contracts.pending': 'Proposé',
  'counterparty-contracts.received': 'A recevoir',
  'counterparty-contracts.sampling': 'Échantillonnage',
  'counterparty-contracts.proposed': 'À proposer',
  'counterparty-contracts.total': 'Total',
  'counterparty-contracts.quality': 'Qualité',
  'counterparty-contracts.grain': 'Grain',

  // Contract Line Items
  'contract-line-items.add-new': 'Nouvelle fixation',
  'contract-line-items.create-new': 'Créer une fixation de contrat',
  'contract-line-items.contract-number': 'Fixation du contrat #{0}',
  'contract-line-items.client': 'Client',
  'contract-line-items.exporter': 'Exportateur',
  'contract-line-items.final-contract': 'Contrat Final',
  'contract-line-items.number': 'Nombre',
  'contract-line-items.volume': 'Volume',
  'contract-line-items.product': 'Produit',
  'contract-line-items.execution-period': "Période d'exécution",
  'contract-line-items.boarding-period': "Période d'embarquement",
  'contract-line-items.differential': 'Différentiel',
  'contract-line-items.material-fixing-date': 'Date de fixation matière',
  'contract-line-items.currency-fixing-date': 'Date de fixation de la devise',
  'contract-line-items.fixing-price-gbp': 'Prix de fixation Gbp',
  'contract-line-items.total-fob-price': 'Prix Fob total',
  'contract-line-items.price-quality': 'Prix qualité',
  'contract-line-items.cyrian-basic-price': 'Prix de base de Cyrian',
  'contract-line-items.cyrian-discount': 'Rabais Cyrian',
  'contract-line-items.graining': 'Grainage',
  'contract-line-items.signature': 'Signature',

  // Contract Product
  'contract-product.product': 'Produit',
  'contract-product.quality': 'Qualité',
  'contract-product.gr': 'gr',
  'contract-product.volume': 'Volume',

  // CVs
  'cvs.add-new': 'Ajouter Déverrouillage CV',
  'cvs.create': 'Créer un CV',
  'cvs.cv-number': 'CV #{0}',
  'cvs.name': 'Nom',
  'cvs.number': 'Nombre',
  'cvs.volume': 'Volume',
  'cvs.price': 'Prix',
  'cvs.currency': 'Devise',
  'cvs.taxes': 'Impôts',
  'cvs.counterparty': 'Contrepartie',
  'cvs.campaign': 'Campagne',
  'cvs.period': 'Période de déblocage',
  'cvs.unlocking-date': 'Date de déblocage',
  'cvs.cv-unlocking': 'N° CV de déblocage',
  'cvs.balance': 'Équilibre',

  // CV Executions
  'cv-executions.add-new': 'Add Execution CV',
  'cv-executions.create': 'Créer une exécution de CV',
  'cv-executions.edit-number': 'Exécution de CV #{0}',
  'cv-executions.counterparty': 'Contrepartie',
  'cv-executions.cv-unlocking': 'N° de déblocage',
  'cv-executions.cv-execution': "N° CV d'exécution",
  'cv-executions.unlocking-period': 'Période de déblocage initiale',
  'cv-executions.execution-period': "Période d'exécution",
  'cv-executions.campaign': 'Campagne',
  'cv-executions.volume': 'Volume',
  'cv-executions.price': 'Prix',
  'cv-executions.number': 'Nombre',
  'cv-executions.unlocking-date': 'Date de déblocage',

  // Lots
  'lots.filter-all': 'Tous',
  'lots.filter-empty-only': 'Lots vides uniquement',
  'lots.add-new': 'Ajouter un lot',
  'lots.mass-add-new': 'Ajouter des lots',
  'lots.mass-remove': 'Supprimer des lots',
  'lots.mass-add-pledges': 'Nantir',
  'lots.mass-add-fumigation': 'Ajouter une fumigation',
  'lots.mass-add-bv': 'Ajouter BV',
  'lots.associate-product': 'Associer un produit',
  'lots.clearAllFilters': 'Effacer tous les filtres',
  'lots.create-new': 'Créer un lot',
  'lots.create-from-excel': "Créer à partir d'Excel",
  'lots.link-lots-waybills': "Importer le rapport d'usinage",
  'lots.processingReportTemplate': 'Modèle de rapport',
  'lots.link-lots-waybills.factory-not-found-title': "Adresse d'usine introuvable",
  'lots.link-lots-waybills.factory-not-found-desc':
    "Le modèle de rapport d'usinage « {0} » nécessite une adresse d'usine correspondante, qui n'existe pas encore dans la base. Créez-la dans le carnet d'adresses, puis réimportez le rapport.",
  'lots.link-lots-waybills.factory-not-found-action': 'Ouvrir les adresses',
  'lots.lot-number': 'Lot #{0}',
  'lots.count': 'Compter',
  'lots.unblock-cv': 'N° Cv de déblocage',
  'lots.execution-cv': "N° CV d'exécution",
  'lots.bv': 'BV',
  'lots.bv-expiration-date': "Date d'expiration du BV",
  'lots.campaign': 'Campagne',
  'lots.proposal-contract': 'Contrat de proposition',
  'lots.proposal-status': 'Statut de la proposition',
  'lots.owner': 'Propriétaire',
  'lots.final-client': 'Client final',
  'lots.product': 'Type de cacao',
  'lots.production-status': 'Statut du lot',
  'lots.fo': 'FO',
  'lots.to': 'To',
  'lots.containers': 'Conteneurs',
  'lots.number': 'Numéro de lot',
  'lots.sacks-quantity': 'Quantité de sacs',
  'lots.theoretical-weight': 'Poids Thq',
  'lots.weight': 'Poids',
  'lots.fo1': 'N° Fo1',
  'lots.mass-create-warn': 'Les lots #{0} existent déjà',
  'lots.mass-create-warn2': 'Certains lots existent déjà',
  'lots.factory': 'Usine',
  'lots.location': 'Emplacement',
  'lots.final-contract': 'Contrat final',
  'lots.production-date': 'Date de production',
  'lots.quality': 'Qualité',
  'lots.delete-warning-title': 'Avertissement',
  'lots.delete-warning-desc': 'Êtes-vous sûr de vouloir supprimer ces lots ?',

  'lots.production-status.To produce': 'A produire',
  'lots.production-status.Under production': 'En cours de production',
  'lots.production-status.Produced': 'Produit',

  'lots.events': 'Evénements liés au lot',
  'lots.events.id': 'Id',
  'lots.events.type': 'Taper',
  'lots.events.namespace': 'Espace de noms',
  'lots.events.comment': 'Commenter',
  'lots.events.date': 'Date',
  'lots.waybills.relatedLots': 'Lots associés',
  'lots.pull-report': 'Générer le rapport',
  'lots.export.title': "Rapport d'export ({0} lots)",
  'lots.export.no-selection': 'Aucun lot sélectionné. Revenez en arrière et sélectionnez des lots à exporter.',
  'lots.export.download': 'Exporter vers Excel',
  'lots.export.polygon-banner': '{0} / {1} parcelles ont un polygone',
  'lots.export.section.cooperatives': 'Coopératives',
  'lots.export.section.farmers': 'Producteurs & Volumes',
  'lots.export.section.polygons': 'Polygones',
  'lots.export.tab.summary': 'Synthèse',
  'lots.export.tab.cooperatives': 'Coopératives',
  'lots.export.tab.farmers': 'Producteurs & Volumes',
  'lots.export.tab.polygons': 'Polygones',
  'lots.export.col.lot': 'Lot',
  'lots.export.col.product': 'Produit',
  'lots.export.col.cooperatives-count': 'Nb coopératives',
  'lots.export.col.farmers-count': 'Nb producteurs',
  'lots.export.col.lot-weight': 'Poids du lot (kg)',
  'lots.export.col.polygon-coverage': 'Couverture polygones',
  'lots.export.col.cooperative': 'Coopérative',
  'lots.export.col.code': 'Code',
  'lots.export.col.consortium': 'Consortium',
  'lots.export.col.deliveries': 'Livraisons',
  'lots.export.col.supplied-kg': 'Fourni (kg)',
  'lots.export.col.bags': 'Sacs',
  'lots.export.col.farmer': 'Producteur',
  'lots.export.col.farmer-id': 'ID producteur',
  'lots.export.col.delivery': 'Livraison',
  'lots.export.col.volume-kg': 'Volume (kg)',
  'lots.export.col.plots-total': 'Parcelles totales',
  'lots.export.col.with-polygon': 'Avec polygone',
  'lots.export.col.coverage-percent': 'Couverture %',
  'lots.export.section.waybills': 'Bordereaux',
  'lots.export.tab.waybills': 'Bordereaux',
  'lots.export.col.waybill': 'Bordereau',
  'lots.export.col.campaign': 'Campagne',
  'lots.export.col.declared-net-weight-kg': 'Poids net déclaré (kg)',

  // Lot Analysis
  'lot.analysis': 'Analyse',
  'lot.analysis.title': 'Analysis for Lot #{0}',
  'lot.analysis.address': 'Adresse',
  'lot.bv': 'BV',
  'lot.analysis.counterparty': 'Contrepartie',
  'lot.analysis.analysis-date': "Date d'analyse",
  'lot.analysis.sampling-date': "Date d'échantillonnage",
  'lot.analysis.sampling-method': "Méthode d'échantillonnage",
  'lot.analysis.analysis-reference': "Référence d'analyse",
  'lot.analysis.sampling-reference': "Référence d'échantillonnage",
  'lot.analysis.classification': 'Classification',
  'lot.analysis.document-url': 'URL du document',
  'lot.analysis.total-sample-weight': "Poids total de l'échantillon",
  'lot.analysis.specific-weight-100g': 'Poids spécifique sur 100g',
  'lot.analysis.graining': 'Grainage',
  'lot.analysis.humidity': 'Humidité',
  'lot.analysis.screening-scrap': 'Dépistage de la ferraille',
  'lot.analysis.flat-beans': 'Haricots plats',
  'lot.analysis.crabots': 'Crabots',
  'lot.analysis.foreign-bodies': 'Corps étranger',
  'lot.analysis.broken-beans': 'Haricots cassés',
  'lot.analysis.fragments': 'Fragments',
  'lot.analysis.shell': 'Coquille',
  'lot.analysis.materials-derived': 'Matériaux dérivés',
  'lot.analysis.moldy': 'Moisi',
  'lot.analysis.moths': 'Papillons de nuit',
  'lot.analysis.slate': 'Ardoise',
  'lot.analysis.germinated': 'Germé',
  'lot.analysis.violets': 'Violettes',
  'lot.analysis.buttered': 'Beurré',

  // Lot Fumigation
  'lot.fumigation': 'Fumigation',
  'lot.fumigation.title': 'Fumigation for Lot #{0}',
  'lot.fumigation.location': 'Lieu',
  'lot.fumigation.start-date': 'Date de début',
  'lot.fumigation.end-date': 'Date de fin',

  // Lot Pledge
  'lot.pledge': 'Engagement',
  'lot.pledge.title': 'Pledge for Lot #{0}',
  'lot.product.title': 'Associer un produit aux lots #{0}',
  'lot.pledge.counterparty': 'Contrepartie',
  'lot.pledge.request-number': 'Numéro de demande',
  'lot.pledge.ltd-number': 'ltdNumber',
  'lot.pledge.das-dae': 'dasDae',

  // Lot Weighing
  'lot.weighing': 'Pesé',
  'lot.weighing.title': 'Weighing for Lot #{0}',
  'lot.weighing.address': 'Adresse',
  'lot.weighing.counterparty': 'Contrepartie',
  'lot.weighing.date': 'Date',
  'lot.weighing.weight': 'Poids',

  // Products
  'products.add-new': 'Ajouter un produit',
  'products.create-new': 'Créer un produit',
  'products.product-number': 'Produit #{0}',
  'products.name': 'Nom',
  'products.type': 'Label',
  'products.sampling-method': "Méthode d'échantillonnage",
  'products.quality.Low': 'Bas',
  'products.quality.Medium': 'Moyen',
  'products.quality.High': 'Haut',
  'products.quality.G1': 'G1',
  'products.quality.G2': 'G2',
  'products.quality.SG': 'SG',
  'products.type.Ordinary': 'Ordinaire',
  'products.type.Utz': 'Utz',
  'products.type.Fair trade': 'Fair trade',
  'products.type.Rainforest alliance': 'Rainforest alliance',
  'products.type.Cocoa Life': 'Cocoa Life',
  'products.type.Premius Cyrian': 'Premius Cyrian',

  // Attachments
  'attachments.attachments': 'Fichiers',
  'attachments.title': 'Pièces jointes pour #{0}',
  'attachments.uploading': 'Téléchargement',
  'attachments.start-upload': 'Commence le téléchargement',
  'attachments.name': 'Nom',
  'attachments.created': 'Créé',
  'attachments.Size': 'Taille',

  // Proposal
  'proposal.create': 'Créer une proposition pour le lot #{0}',
  'proposal.add-many': 'Ajouter des propositions',
  'proposal.update': 'Mettre à jour la proposition #{0}',
  'proposal.new-status': 'Nouveau statut de proposition',
  'proposal.status': 'Statut',
  'proposal.update-status': 'Mettre à jour le statut de la proposition pour le lot #{0}',
  'proposal.mass-update-status': 'État de la proposition de mise à jour en masse',
  'proposal.contract-initial': 'Client contractuel initial',
  'proposal.contract-final': 'Contrat Client Final',
  'proposal.mass-sampling': 'Échantillonnage de masse',
  'proposal.mass-accepted': 'Masse acceptée',
  'proposal.mass-rejected': 'Masse rejetée',
  'proposal.customer': 'Client',
  'proposal.selected-lots': 'Lots sélectionnés',
  'proposal.code': 'Code',
  'proposal.status.withdrawn': 'Avec Drawn',
  'proposal.status.pending': 'En attente',
  'proposal.status.accepted': 'Accepté',
  'proposal.status.rejected': 'Rejeté',

  // Boardings
  'boardings.add-new': 'Ajouter un embarquement',
  'boardings.create-new': 'Créer un embarquement',
  'boardings.boarding-number': 'Embarquement #{0}',
  'boardings.contract': 'Contrat',
  'boardings.container': 'Récipient',
  'boardings.departure-address': 'Port de départ',
  'boardings.internal-client': 'Client interne',
  'boardings.final-client': 'Client final',
  'boardings.consignee': 'Destinataire',
  'boardings.final-consignee': 'Destinataire final',
  'boardings.freight-payer': 'Payeur de fret',
  'boardings.internal-client-contract': 'Contrat client interne',
  'boardings.final-client-contract': 'Contrat du client final',
  'boardings.service-contract': 'Contrat de service',
  'boardings.notify': 'Notifié',
  'boardings.sea-line': 'Ligne maritime',
  'boardings.product': 'Produit',
  'boardings.harbor-address': 'Adresse du port',
  'boardings.destination-address': 'Port de destination',
  'boardings.campaign': 'Campagne',
  'boardings.exporter': 'Exportateur',
  'boardings.inspector': 'Inspecteur',
  'boardings.shipowner': 'Armateur',
  'boardings.courier': 'Courrier',
  'boardings.container-type': 'Type de containeurs',
  'boardings.number': 'Numéro',
  'boardings.volume': 'Volume',
  'boardings.date': 'Date d’instruction d’embarquement',
  'boardings.warning': 'Avertissement',
  'boardings.warning-product-not-contract': 'Vous avez sélectionné un produit autre que le contrat indiqué',
  'boardings.si-number': 'Numéro SI',
  'boardings.quantity-mt': 'Quantité (MT)',
  'boardings.certification-level': 'Niveau de certification',
  'boardings.packing': 'Emballage',
  'boardings.pending-amendment': 'Amendement en attente',
  'boardings.pending-amendment-tooltip':
    'Un amendement SI non approuvé fait référence à cet embarquement — son approbation sur la page Imports SI mettra à jour cet embarquement.',
  'boardings.imports.title': "Imports d'instructions d'embarquement",
  'boardings.imports.subtitle':
    'Les SI clients arrivent par e-mail et sont analysées automatiquement — vérifiez chacune pour créer ou mettre à jour un embarquement',
  'boardings.imports.refresh': 'Actualiser',
  'boardings.imports.badge.reused':
    "Lié à l'import #{id} — même document ; cette ligne reprend les données extraites de cet import.",
  'boardings.imports.column.file': 'Fichier',
  'boardings.imports.column.si-number': 'Numéro SI',
  'boardings.imports.column.status': 'Statut',
  'boardings.imports.column.created': 'Créé le',
  'boardings.imports.column.result': 'Résultat',
  'boardings.imports.column.actions': 'Actions',
  'boardings.imports.status.pending': "En file d'attente",
  'boardings.imports.status.parsed': 'Traitement…',
  'boardings.imports.status.persisted': 'Approuvé',
  'boardings.imports.status.review': 'À vérifier',
  'boardings.imports.status.failed': 'Échec',
  'boardings.imports.result.boarding-link': 'Embarquement n°{id}',
  'boardings.imports.result.amendment': "Amendement de l'embarquement n°{id}",
  'boardings.imports.result.amendment-tooltip':
    "Ce numéro SI correspond à l'embarquement n°{id} — l'approbation mettra à jour cet embarquement au lieu d'en créer un nouveau.",
  'boardings.imports.result.warnings': '{count, plural, one {# avertissement} other {# avertissements}}',
  'boardings.imports.actions.review': 'Vérifier et approuver',
  'boardings.imports.actions.force-reparse': 'Forcer une nouvelle analyse',
  'boardings.imports.actions.force-reparse-confirm-persisted':
    "Relancer l'extraction IA sur ce document ? Une nouvelle ligne d'import est créée ; les lignes existantes sont conservées. L'embarquement lié et les lignes existantes ne changent qu'après votre approbation du nouveau résultat.",
  'boardings.imports.actions.force-reparse-confirm-other':
    "Relancer l'extraction IA sur ce document ? Une nouvelle ligne d'import est créée ; cette ligne est conservée et y renvoie. Aucun embarquement n'est encore lié, il s'agit donc simplement d'une nouvelle analyse.",
  'boardings.imports.delete.unreachable':
    "Impossible de joindre le serveur. Votre suppression n'a peut-être pas abouti — actualisez pour vérifier.",
  'boardings.imports.mailbox.last-checked': 'Dernière vérification de la boîte mail : {when}',
  'boardings.imports.mailbox.never': 'jamais',
  'boardings.imports.mailbox.min-ago':
    "{minutes, plural, =0 {à l'instant} one {il y a # minute} other {il y a # minutes}}",
  'boardings.imports.quarantine.title': 'E-mails en quarantaine ({count})',
  'boardings.imports.quarantine.column.received': 'Reçu le',
  'boardings.imports.quarantine.column.from': 'Expéditeur',
  'boardings.imports.quarantine.column.subject': 'Objet',
  'boardings.imports.quarantine.column.reason': 'Motif',
  'boardings.imports.quarantine.dismiss': 'Rejeter',
  'boardings.imports.quarantine.dismiss-confirm':
    "Rejeter cet e-mail ? L'enregistrement est conservé pour audit, mais il quittera la liste de quarantaine.",
  'boardings.imports.quarantine.dismissed': 'E-mail rejeté',
  'boardings.imports.review.title': "Vérifier l'instruction d'embarquement",
  'boardings.imports.review.banner.amendment':
    "Ce numéro SI correspond à l'embarquement n°{id} — l'approbation mettra à jour cet embarquement au lieu d'en créer un nouveau.",
  'boardings.imports.review.banner.create':
    "Aucun embarquement existant ne correspond à ce numéro SI — l'approbation en créera un.",
  'boardings.imports.review.banner.low_confidence':
    "L'OCR n'a pas pu lire certains champs avec certitude. Vérifiez les champs surlignés et corrigez-les avant d'approuver.",
  'boardings.imports.review.banner.entity_not_found':
    'Certaines valeurs ne correspondent pas aux données de référence. Corrigez les champs surlignés ou créez les enregistrements manquants, puis approuvez de nouveau.',
  'boardings.imports.review.uncertain_field_tooltip':
    "L'OCR a signalé ce champ comme peu fiable. Vérifiez avec le document original.",
  'boardings.imports.review.required': 'Ce champ est obligatoire.',
  'boardings.imports.review.submit': 'Approuver',
  'boardings.imports.review.cancel': 'Annuler',
  'boardings.imports.review.submit_success': "Instruction d'embarquement approuvée.",
  'boardings.imports.review.submit_parked':
    "L'approbation n'a pas abouti — certaines références n'ont pas pu être résolues. Vérifiez les champs surlignés.",
  'boardings.imports.review.submit_failed': "Échec de l'approbation.",
  'boardings.imports.review.section.extracted': 'Extrait du document',
  'boardings.imports.review.section.approval': "Détails d'approbation",
  'boardings.imports.review.siNumber': 'Numéro SI',
  'boardings.imports.review.quantityMt': 'Quantité (MT)',
  'boardings.imports.review.purchaseContractNumber': 'N° de contrat d’achat',
  'boardings.imports.review.serviceContractNumber': 'N° de contrat de service',
  'boardings.imports.review.destination': 'Port de destination',
  'boardings.imports.review.consignee': 'Destinataire',
  'boardings.imports.review.freightPayer': 'Payeur du fret',
  'boardings.imports.review.notifyParties': 'Parties à notifier',
  'boardings.imports.review.shippingLine': 'Compagnie maritime',
  'boardings.imports.review.containerType': 'Type de conteneur',
  'boardings.imports.review.packing': 'Emballage',
  'boardings.imports.review.certificationLevel': 'Niveau de certification',
  'boardings.imports.review.lotNumbers': 'Numéros de lots',
  'boardings.imports.review.requiredDocuments': 'Documents requis',
  'boardings.imports.review.date': "Date d'embarquement",
  'boardings.imports.review.exporter': 'Exportateur',
  'boardings.imports.review.number': "Numéro d'embarquement",
  'boardings.imports.review.number-placeholder': 'Par défaut : le numéro SI',
  'boardings.imports.review.product': 'Produit',
  'boardings.imports.review.product-placeholder': "Auto — dérivé du contrat d'achat",
  'boardings.imports.review.container': 'Conteneur',
  'boardings.imports.review.container-placeholder': 'Auto — résolu depuis le type de conteneur',
  'boardings.imports.review.harbor.create_inline': 'Créer le port',
  'boardings.imports.review.harbor.create_missing':
    'Le nom de la destination est requis avant de créer un nouvel enregistrement.',
  'boardings.imports.review.harbor.create_success': 'Port {name} créé.',
  'boardings.imports.review.harbor.already_exists': 'Le port {name} existe déjà. Aucun nouvel enregistrement créé.',
  'boardings.imports.review.harbor.dup_check_overflow':
    'Trop de ports pour vérifier les doublons en toute sécurité — créez le port via Admin → Adresses.',

  // Transit Orders
  'transit-orders.add-new': 'Ajouter une demande de transit',
  'transit-orders.create-new': 'Créer une demande de transit',
  'transit-orders.transit-order-number': 'Ordre de transit #{0}',
  'transit-orders.boarding': 'Embarquement',
  'transit-orders.order-number': 'N° de commande',
  'transit-orders.booking-number': 'N° de réservation',
  'transit-orders.bill-of-lading-number': 'N° de connaissement',
  'transit-orders.forwarder-file-number': 'Numéro de fichier du transitaire',
  'transit-orders.ship-name': 'Nom du Bateau',
  'transit-orders.good-to-embark': 'Bon à embarquer',
  'transit-orders.net-weight': 'Net Lester',
  'transit-orders.eta-date': 'Eta Date',
  'transit-orders.swb-date': 'Swb Date',
  'transit-orders.available-bv-volume': 'Volume Bv disponible pour la formule',
  'transit-orders.formulas-launched': 'Formules lancées',
  'transit-orders.gross-weight-diff': 'Poids Net Poids Brut Diff',
  'transit-orders.theoretical-weight': 'Poids théorique',
  'transit-orders.container': 'Récipient',
  'transit-orders.departure-address': 'Port de départ',
  'transit-orders.internal-client': 'Client interne',
  'transit-orders.final-client': 'Client final',
  'transit-orders.consignee': 'Destinataire',
  'transit-orders.final-consignee': 'Final consignee',
  'transit-orders.freight-payer': 'Payeur de fret',
  'transit-orders.internal-client-contract': 'Contrat client interne',
  'transit-orders.final-client-contract': 'Contrat du client final',
  'transit-orders.service-contract': 'Contrat de service',
  'transit-orders.freight-forwarder': 'Transitaire',
  'transit-orders.product': 'Produit',
  'transit-orders.exporter': 'Exportateur',
  'transit-orders.destination-address': 'Port de destination',

  // Containers
  'containers.add-new': 'Ajouter un conteneur',
  'containers.create-new': 'Créer un conteneur',
  'containers.container-number': 'Récipient #{0}',
  'containers.name': 'Nom',
  'containers.type': 'Taper',
  'containers.sacs-type': 'Type de sacs',
  'containers.dressing-material': 'Matériel de pansement',

  // Transfers
  'transfers.add-new': 'Ajouter Transferts',
  'transfers.create-new': 'Créer Transferts',
  'transfers.transfer-number': 'Transferts #{0}',
  'transfers.product': 'Produit',
  'transfers.campaign': 'Campagne',
  'transfers.carrier': 'Transporteur',
  'transfers.transport-charge-counterparty': 'Prise en charge du transport',
  'transfers.loading-counterparty': 'Chargement et déchargement par',
  'transfers.start-location': 'Magasin de provenance',
  'transfers.end-location': 'Magasin de destination',
  'transfers.number': 'N° de dossier',
  'transfers.status': 'Statut',
  'transfers.phyto-position': 'Position phyto',
  'transfers.phyto-treatment-days': 'Nbre de jours de traitement',
  'transfers.phone-number': 'Téléphone',
  'transfers.status.arrived': 'Arrivée',
  'transfers.status.departed': 'Commencé',
  'transfers.status.in transit': 'En transit',

  // User Settings
  'user-settings.items-per-page': 'Articles par page',
  'user-settings.dump-data': 'Télécharger les données',
  'user-settings.title': 'Paramètres',

  // Profile
  'profile.title': 'Profil',
  'profile.email': 'E-mail',
  'profile.name': 'Nom',
  'profile.role': 'Rôle',

  // Formulas
  'formulas.add-new': 'Ajouter une formule',
  'formulas.create-new': 'Créer une formule',
  'formulas.formula-number': 'Formule #{0}',
  'formulas.exporter': 'Exportateur',
  'formulas.freight-forwarder': 'Transitaire',
  'formulas.product': 'Produit',
  'formulas.campaign': 'Campagne',
  'formulas.destination': 'Destination',
  'formulas.departure-port': 'Port de départ',
  'formulas.recipient': 'Destinataire',
  'formulas.execution-cv': "Cv d'exécution",
  'formulas.authorization-number': "N° d'autorisation",
  'formulas.harvest': 'Récolter',
  'formulas.grade': 'Noter',
  'formulas.quality': 'Qualité',
  'formulas.net-weight': 'Poids net',
  'formulas.gross-weight': 'Poids brut',
  'formulas.packaging': 'Emballage',
  'formulas.packaging-count': "Nombre d'emballages",
  'formulas.customs-nomenclature': 'Nomenclature douanière',
  'formulas.ship': 'Bateau',
  'formulas.fO1Date': 'fO1Date',

  // Formula Payments
  'formula.payment.payments': 'Paiements',
  'formula.payment.add-new': 'Ajouter un paiement',
  'formula.payment.create-new': 'Créer un paiement',
  'formula.payment.payment-number': 'Paiement #{0}',
  'formula.payment.type': 'Taper',
  'formula.payment.weight': 'Poids',
  'formula.payment.rate': 'Taux',
  'formula.payment.support': 'Support',

  // Formula Taxes
  'formula.taxes.taxes': 'Impôts',
  'formula.taxes.add-new': 'Ajouter une taxe',
  'formula.taxes.create-new': 'Créer une taxe',
  'formula.taxes.tax-number': 'Impôt #{0}',
  'formula.taxes.bank': 'Banque',
  'formula.taxes.price': 'Prix',
  'formula.taxes.name': 'Nom',
  'formula.taxes.check': 'Vérifier',
  'formula.taxes.rate': 'Taux',
  'formula.taxes.date': 'Date',

  // Farmers
  'farmers.add-new': 'Ajouter un producteur',
  'farmers.create-from-excel-by-type': "Créer à partir d'Excel",
  'farmers.id': 'ID',
  'farmers.identifier': 'Identifiant',
  'farmers.farmerId': 'ID Producteur',
  'farmers.farmId': 'ID Exploitation',
  'farmers.firstName': 'Prénom',
  'farmers.lastName': 'Nom',
  'farmers.counterparty': 'Nom du producteur',
  'farmers.cooperative': 'Coopérative',
  'farmers.farms': 'Exploitations',
  'farmers.gender': 'Genre',
  'farmers.phone': 'Téléphone',
  'farmers.dob': 'Date de naissance',
  'farmers.product': 'Produit',
  'farmers.village': 'Village',
  'farmers.district': 'District',
  'farmers.region': 'Région',
  'farmers.surfaceAreaHa': 'Superficie (ha)',
  'farmers.nationalId': 'ID National',
  'farmers.sourceDocumentType': 'Type de document source',
  'farmers.plotsCount': 'Nombre de parcelles',
  'farmers.totalFarmAreaHa': "Superficie de l'exploitation (ha)",
  'farmers.latitude': 'Latitude',
  'farmers.longitude': 'Longitude',
  'farmers.createdAt': 'Créé le',
  'farmers.updatedAt': 'Mis à jour le',
  'farmers.plotsTab': 'Parcelles',

  // Farmer Plots
  'farmer.farmer-plot.farmerId': 'ID Producteur',
  'farmer.farmer-plot.farmId': 'ID Exploitation',
  'farmer.farmer-plot.plotId': 'ID Parcelle',
  'farmer.farmer-plot.plotAreaHa': 'Superficie de la parcelle (ha)',
  'farmer.farmer-plot.latitude': 'Latitude',
  'farmer.farmer-plot.longitude': 'Longitude',
  'farmer.farmer-plot.createdAt': 'Créé le',
  'farmer.farmer-plot.updatedAt': 'Mis à jour le',

  // Farms
  'farms.tabTitle': 'Exploitations',
  'farms.farmId': 'ID Exploitation',
  'farms.farmerId': 'ID Producteur',
  'farms.farmer': 'Producteur',
  'farms.product': 'Produit',
  'farms.village': 'Village',
  'farms.district': 'District',
  'farms.region': 'Région',
  'farms.plotsCount': 'Nombre de parcelles',
  'farms.polygonsMap': 'Polygones des parcelles',
  'farms.noPolygons': 'Aucune donnée de polygones pour les parcelles',
  'farms.open': 'Ouvrir',

  // Dashboard
  'dashboard.refresh': 'Actualiser',
  'dashboard.totalAcceptedWeight': 'Poids total accepté',
  'dashboard.totalAcceptedBags': 'Nombre total de sacs acceptés',
  'dashboard.totalLotWeight': 'Poids total des lots',
  'dashboard.totalLotsCount': 'Nombre total de lots',
  'dashboard.farmersCount': 'Producteurs uniques',
  'dashboard.cooperativesCount': 'Coopératives uniques',
  'dashboard.others': 'Autres',
  'dashboard.productSplit': 'Poids par produit',
  'dashboard.productName': 'Produit',
  'dashboard.productWeight': 'Poids',
  'dashboard.harborSplit': 'Poids par port',
  'dashboard.harborName': 'Port',
  'dashboard.harborWeight': 'Poids',
  'dashboard.consortiumSplit': 'Poids par consortium',
  'dashboard.consortiumName': 'Consortium',
  'dashboard.consortiumWeight': 'Poids',
  'dashboard.emptyProductSplit':
    'Aucun poids accepté par produit sur cette période (lignes de pesée des bordereaux peut‑être absentes — vérifier l’import recepjournalier).',
  'dashboard.emptyHarborSplit': 'Aucun poids accepté par port sur cette période (pesées ou port manquants).',
  'dashboard.emptyConsortiumSplit':
    'Aucun poids accepté par consortium sur cette période (liens coopérative–consortium ou pesées manquants).',
  'dashboard.waybillKpiIncomplete':
    'Des lots existent sur cette période mais le poids accepté des bordereaux est nul. Les analyses de pesée proviennent de l’import recepjournalier ; lier seulement les lots aux bordereaux ne remplit pas ces indicateurs.',
  'dashboard.error.title': 'Échec du chargement des données du tableau de bord',
  'dashboard.error.subtitle': "Désolé, quelque chose s'est mal passé. Veuillez réessayer plus tard.",
  'dashboard.tryAgain': 'Réessayer',
  'dashboard.admin.title': "Actions de l'administrateur",
  'dashboard.admin.description':
    'Déclencher manuellement un recalcul des statistiques pour un jour spécifique. Ceci est utile si des données passées ont été corrigées ou ajoutées tardivement.',
  'dashboard.admin.recalculate': 'Recalculer',
  'dashboard.quickFilter.week': 'Semaine en cours',
  'dashboard.quickFilter.month': 'Mois en cours',
  'dashboard.quickFilter.mainCrop': 'Grande récolte (campagne sélectionnée)',
  'dashboard.quickFilter.midCrop': 'Mi-récolte ({year})',
  'dashboard.filter.campaign': 'Campagne pour filtres de saison',
  'dashboard.filter.products': 'Filtrer par Produit',
  'dashboard.filters.cardTitle': 'Filtres',
  'dashboard.filters.periodTitle': 'Période du rapport',
  'dashboard.filters.productsTitle': 'Produits',
  'dashboard.filters.campaignSeasonTitle': 'Plage rapide — saisons de campagne',
  'dashboard.filters.campaignSeasonHint':
    'La liste commence vide : les indicateurs suivent uniquement la période ci-dessus. Choisissez une campagne, puis Grande ou Mi-récolte pour y appliquer les dates de saison configurées.',

  // Waybills (refactored from bols)
  'waybills.add-new': 'Bordereau',
  'waybills.create-new': 'Créer un bordereau',
  'waybills.waybill-number': 'Bordereau #{0}',
  'waybills.product': 'Produit',
  'waybills.campaign': 'Campagne',
  'waybills.waybillNumber': 'N° de connaissement',
  'waybills.factory': 'Usine',
  'waybills.harbor': 'Port',
  'waybills.cooperative': 'Coopérative',
  'waybills.exporter': 'Exportateur',
  'waybills.productNature': 'Nature produit',
  'waybills.status': 'Statut',
  'waybills.status.IN_PROGRESS': 'En cours',
  'waybills.status.REFUSED': 'Refusé',
  'waybills.status.DONE': 'Terminé',
  'waybills.clearAllFilters': 'Effacer tous les filtres',
  'waybills.create-from-excel': "Créer à partir d'Excel",
  'waybills.createFromPdf': 'Imports PDF en lot',
  'waybills.imports.title': 'Imports de PDF de bordereaux',
  'waybills.imports.subtitle': 'Déposez des PDF CEU et laissez Gemini les traiter en arrière-plan',
  'waybills.imports.dropzone.title': 'Cliquez ou glissez des fichiers PDF ici',
  'waybills.imports.dropzone.hint':
    'Plusieurs fichiers acceptés. Chaque PDF déclenche un traitement indépendant. 30 Mo max par fichier.',
  'waybills.imports.status.queued': 'En attente…',
  'waybills.imports.status.uploading': 'Envoi…',
  'waybills.imports.status.upload_failed': "Échec de l'envoi",
  'waybills.imports.status.pending': "En file d'attente",
  'waybills.imports.status.parsed': 'Persistance…',
  'waybills.imports.status.persisted': 'Terminé',
  'waybills.imports.status.review': 'À vérifier',
  'waybills.imports.status.failed': 'Échec',
  'waybills.imports.actions.retry': 'Réessayer',
  'waybills.imports.actions.delete': 'Supprimer',
  'waybills.imports.actions.remove': 'Retirer',
  'waybills.imports.actions.retry-upload': "Relancer l'envoi",
  'waybills.imports.leave-confirm.title': 'Quitter cette page ?',
  'waybills.imports.leave-confirm.content':
    'Certains envois ont échoué et ne sont conservés que sur cette page. Si vous la quittez, il faudra redéposer ces PDF.',
  'waybills.imports.leave-confirm.ok': 'Quitter',
  'waybills.imports.leave-confirm.cancel': 'Rester',
  'waybills.imports.badge.reused':
    "Lié à l'import #{id} — même PDF ; cette ligne reprend les données extraites de cet import.",
  'waybills.imports.actions.retry-tooltip': 'Relancer la persistance sur les données déjà extraites',
  'waybills.imports.actions.review': 'Vérifier et confirmer',
  'waybills.imports.actions.force-reparse': 'Forcer la ré-extraction',
  'waybills.imports.actions.force-reparse-confirm-persisted':
    "Relancer l'extraction IA sur ce PDF ? Une nouvelle ligne d'import est créée ; les lignes existantes sont conservées et mises à jour une fois le nouveau résultat enregistré. Le bordereau associé sera alors mis à jour avec les nouvelles données extraites.",
  'waybills.imports.actions.force-reparse-confirm-other':
    "Relancer l'extraction IA sur ce PDF ? Une nouvelle ligne d'import est créée ; cette ligne est conservée et y renvoie. Aucun bordereau n'est encore associé, il s'agit donc d'un simple nouvel essai d'OCR.",
  'waybills.imports.actions.reapply': 'Ré-appliquer les données extraites',
  'waybills.imports.actions.reapply-confirm':
    "Réinjecter les données extraites stockées dans le bordereau associé ? Aucune nouvelle extraction IA ne sera lancée — l'opération utilise les données déjà enregistrées lors de l'import initial.",
  'waybills.imports.review.title': 'Vérifier les données extraites',
  'waybills.imports.review.banner.low_confidence':
    "L'OCR n'a pas pu lire certains champs avec certitude. Vérifiez les entrées surlignées et corrigez-les avant d'enregistrer.",
  'waybills.imports.review.banner.entity_not_found':
    "La valeur surlignée ne correspond à aucun enregistrement existant. Avant de cliquer sur Créer, comparez avec le PDF d'origine — les codes scannés sont souvent mal lus (par ex. 0↔8↔6, S↔5). Si la valeur est correcte et l'enregistrement vraiment nouveau, utilisez Créer la coopérative.",
  'waybills.imports.review.uncertain_field_tooltip':
    "L'OCR a signalé ce champ comme peu fiable. Comparez avec le PDF d'origine.",
  'waybills.imports.review.required': 'Ce champ est requis.',
  'waybills.imports.review.submit': 'Enregistrer',
  'waybills.imports.review.cancel': 'Annuler',
  'waybills.imports.review.submit_success': 'Document enregistré et bordereau lié.',
  'waybills.imports.review.cooperativeCode': 'Code coopérative',
  'waybills.imports.review.cooperativeName': 'Nom coopérative',
  'waybills.imports.review.originDepartment': "Département d'origine",
  'waybills.imports.review.cropPhase': 'Traite',
  'waybills.imports.review.certification': 'Certification',
  'waybills.imports.review.bagCount': 'Nombre de sacs',
  'waybills.imports.review.netWeightKg': 'Poids net (kg)',
  'waybills.imports.review.transportCostFcfa': 'Coût transport (FCFA)',
  'waybills.imports.review.editionDate': "Date d'édition",
  'waybills.imports.review.cooperative.create_inline': 'Créer la coopérative',
  'waybills.imports.review.cooperative.create_confirm': 'Créer la coopérative {code} — {name} ?',
  'waybills.imports.review.cooperative.create_missing':
    'Le code et le nom de la coopérative sont requis avant de créer un nouvel enregistrement.',
  'waybills.imports.review.cooperative.create_success': 'Coopérative {code} créée.',
  'waybills.imports.review.cooperative.already_exists':
    "La coopérative {code} existe déjà. Aucun nouvel enregistrement n'a été créé.",
  'waybills.imports.review.harbor.create_inline': 'Créer le port',
  'waybills.imports.review.harbor.create_missing': 'Le nom du port est requis avant de créer un nouvel enregistrement.',
  'waybills.imports.review.harbor.create_success': 'Port {name} créé.',
  'waybills.imports.review.harbor.already_exists':
    "Le port {name} existe déjà. Aucun nouvel enregistrement n'a été créé.",
  'waybills.imports.refresh': 'Actualiser',
  'waybills.imports.upload.invalid-type': 'Seuls les fichiers PDF sont acceptés.',
  'waybills.imports.upload.queued': "{name} mis en file d'attente",
  'waybills.imports.upload.failed-generic': "Échec de l'envoi. Réessayez ou retirez cette ligne.",
  'waybills.imports.upload.failed-after-leave':
    "{name} n'a pas été envoyé : {error}. Déposez-le à nouveau dans Imports de PDF de bordereaux.",
  'waybills.imports.upload.not-sent-signed-out':
    "Les fichiers encore en file d'attente n'ont pas été envoyés : la session qui les a déposés est terminée. Reconnectez-vous et déposez-les à nouveau.",
  'waybills.imports.split.title': 'Plusieurs bordereaux dans un PDF',
  'waybills.imports.split.hint':
    'Un bordereau par page — chaque page devient un import distinct. Cliquez ou glissez un PDF ici.',
  'waybills.imports.split.splitting': 'Découpage de {name}…',
  'waybills.imports.split.done': '{name} : découpé en {count} bordereaux',
  'waybills.imports.split.failed':
    "Impossible de découper ce PDF : il est protégé par mot de passe ou endommagé. Rien n'a été envoyé.",
  'waybills.imports.split.confirm.title': 'Découper en {count} bordereaux ?',
  'waybills.imports.split.confirm.content':
    '{name} contient {count} pages. Chaque page devient un import de bordereau distinct et un appel à Gemini.',
  'waybills.imports.split.confirm.ok': 'Découper',
  'waybills.imports.split.confirm.cancel': 'Annuler',
  'waybills.imports.split.unavailable':
    'Impossible de préparer ce PDF pour le découpage. Actualisez la page et réessayez.',
  'waybills.imports.split.pages-failed-after-leave':
    "Certaines pages de {name} n'ont pas été envoyées : {error}. Une fois les autres pages analysées, déposez {name} à nouveau dans « Plusieurs bordereaux dans un PDF » (Imports de PDF de bordereaux) : les pages déjà analysées sont reconnues comme doublons.",
  'waybills.imports.split.not-asked-after-leave':
    "{name} ({count} pages) n'a pas été découpé : il faut votre confirmation et la page Imports de PDF de bordereaux a été quittée. Déposez-le à nouveau.",
  'waybills.imports.delete.unreachable':
    "Le serveur n'a pas répondu. La suppression peut ne pas avoir abouti — actualisez la page pour vérifier.",
  'waybills.imports.column.file': 'Fichier',
  'waybills.imports.column.status': 'Statut',
  'waybills.imports.column.created': 'Créé le',
  'waybills.imports.column.result': 'Résultat',
  'waybills.imports.column.actions': 'Actions',
  'waybills.declaredNetWeightKg': 'Poids net (Kg)',
  'waybills.imports.result.waybill-link': 'Bordereau #{id}',
  'waybills.imports.result.warnings': '{count, plural, one {# avertissement} other {# avertissements}}',
  'waybills.add-lab-analyses-from-excel': 'Ajouter des analyses depuis Excel',
  'waybills.lab-analyses.create-from-excel': 'Analyses depuis Excel',
  'waybills.link-with-farmers-from-excel': 'Lier les producteurs depuis Excel',
  'waybills.link-with-farmers-from-excel.success':
    'Les producteurs ont été liés avec succès à partir du fichier Excel.',
  'waybills.link-with-farmers-from-excel.upload-title': 'Cliquez ou déposez ici les fichiers Excel à téléverser',
  'waybills.link-with-farmers-from-excel.upload-hint':
    "Plusieurs fichiers Excel sont pris en charge (.xls, .xlsx), jusqu'à 20 fichiers par envoi. Chaque fichier est traité dans l'ordre.",
  'waybills.link-with-farmers-from-excel.batch.no-files': 'Veuillez ajouter au moins un fichier.',
  'waybills.link-with-farmers-from-excel.batch.too-many': 'Vous pouvez téléverser au maximum {max} fichiers à la fois.',
  'waybills.link-with-farmers-from-excel.batch.invalid-extension':
    'Seuls les fichiers Excel (.xls, .xlsx) sont autorisés.',
  'waybills.link-with-farmers-from-excel.batch.success-all': 'Les {count} fichiers ont été traités avec succès.',
  'waybills.link-with-farmers-from-excel.batch.partial-title': 'Import terminé : {ok} réussis, {fail} en échec',
  'waybills.link-with-farmers-from-excel.batch.all-failed-title': "L'import a échoué pour tous les fichiers",
  'waybills.mass-add-product': 'Associer un produit',
  'waybills.mass-add-factory': 'Associer une usine',
  'waybills.mass-remove': 'Supprimer les Bordereaux',
  'waybills.delete-warning-title': 'Avertissement',
  'waybills.delete-warning-desc': 'Êtes-vous sûr de vouloir supprimer ces bordereaux ?',
  'waybills.latestSupplierName': 'Coopérative',
  'waybills.cooperativeConsortiums': 'Consortiums',
  'waybills.latestSupplierCode': 'Code CCC',
  'waybills.latestWeightingCode': 'Code de pesée',
  'waybills.latestOriginDepartment': 'Origine',
  'waybills.latestAnalyzedAt': "Date d'entrée",
  'waybills.latestNatGrade': 'Grade NAT',
  'waybills.latestFccGrade': 'Grade FCC',
  'waybills.latestBags': 'Nombre de sacs acceptés',
  'waybills.latestAcceptedWeight': 'Poids accepté (kg)',
  'waybills.latestCccExportDatetime': "Date et heure d'exportation CCC",
  'waybills.noData': 'Aucune donnée',
  'waybills.farmers.section': 'Section',
  'waybills.farmers.netWeightKg': 'Poids Net (kg)',
  'waybills.farmers.bagsCount': 'Nombre de sacs',
  'waybills.farmers.purchaseDate': "Date d'achat",
  'waybills.farmers.receiptNumber': 'Numéro de reçu',
  'waybills.lot.title': 'Dernier numéro de lot : #{0}',
  'waybills.lot.number': 'Numéro de lot',
  'waybills.tabs.lots': 'Lots',
  'waybills.lots.lotNumber': 'Numéro de lot',
  'waybills.lots.createdAt': 'Créé le',
  'waybills.lots.updatedAt': 'Modifié le',

  'waybill.addLot': 'Ajouter un lot',
  'waybill.attachLot': 'Associer à un lot',
  'waybill.attachLot.title': 'Associer le bordereau à un lot existant (#{0})',
  'waybill.factory.title': 'Associer une usine pour les bordereaux #{0}',
  'waybill.product.title': 'Associer un produit pour les bordereaux #{0}',
  'waybill.weighing-analysis.title': 'Analyse pour le bordereau #{0}',
  'waybill.weighing-analysis.weighing-code': 'Code de pesée',
  'waybill.weighing-analysis.cooperative': 'Coopérative',
  'waybill.weighing-analysis.cooperative-code': 'Code coopérative',
  'waybill.weighing-analysis.exporter': 'Exportateur',
  'waybill.weighing-analysis.origin-department': "Département d'origine",
  'waybill.weighing-analysis.bags-count': 'Nombre de sacs',
  'waybill.weighing-analysis.accepted-weight': 'Poids accepté',
  'waybill.weighing-analysis.nat-grade': 'Grade NAT',
  'waybill.weighing-analysis.fcc-grade': 'Grade FCC',
  'waybill.weighing-analysis.ccc-export-datetime': "Date et heure d'exportation CCC",
  'waybill.weighing-analysis.weighing-date': 'Date de pesée',
  'waybill.weighing-analysis.analysis-date': "Date d'analyse",
  'waybill.weighing-analysis.bulletin-number': 'N° de bulletin',
  'waybill.weighing-analysis.controller': 'Contrôleur',
  'waybill.weighing-analysis.humidity': 'Humidité',
  'waybill.weighing-analysis.foreign-materials': 'Matières étrangères',
  'waybill.weighing-analysis.graininess': 'Grainage',
  'waybill.weighing-analysis.slate-beans': 'Fèves ardoisées',
  'waybill.weighing-analysis.moldy-beans': 'Fèves moisies',
  'waybill.weighing-analysis.broken-beans': 'Fèves brisées',
  'waybill.weighing-analysis.waste': 'Déchets',
  'waybill.weighing-analysis.crabots': 'Crabots',
  'waybill.weighing-analysis.defective-beans': 'Fèves défectueuses',
  'waybill.weighing-analysis.violet-beans': 'Fèves violettes',

  'attachment-history.name': 'Nom du fichier',
  'attachment-history.type': 'Type',
  'attachment-history.object': 'Objet',
  'attachment-history.size': 'Taille',
  'attachment-history.mimetype': 'Format',
  'attachment-history.uploadedBy': 'Chargé par',
  'attachment-history.createdAt': 'Chargé le',
  'attachment-history.attachment-type.CV': 'CV',
  'attachment-history.attachment-type.BV': 'BV',
  'attachment-history.attachment-type.ContractLineItem': 'Ligne de contrat',
  'attachment-history.attachment-type.CVExecution': 'Exécution CV',
  'attachment-history.attachment-type.CooperativeLegal': 'Coopérative (juridique)',
  'attachment-history.attachment-type.CooperativePolygon': 'Polygone coopérative',
  'attachment-history.attachment-type.Lot': 'Lot',
  'attachment-history.attachment-type.LotAnalysis': 'Analyse de lot',
  'attachment-history.attachment-type.LotFumigation': 'Fumigation de lot',
  'attachment-history.attachment-type.LotPledge': 'Nantissement de lot',
  'attachment-history.attachment-type.LotWeighing': 'Pesée de lot',
  'attachment-history.attachment-type.Waybill': 'Lettre de voiture',
  'attachment-history.attachment-type.Transfer': 'Transfert',
  'attachment-history.attachment-type.Other': 'Autre',
};
